export const MASS_INVOICE_ACTIONS_TRANSLATIONS = {
  APPROVE_TITLE: 'Régler ces factures :',
  PAID_OUTSIDE_TITLE: 'Factures déjà payées :',
  SET_DATE: 'à une date de paiement donnée',
  USE_DEADLINE_DATE: `à leur date d'échéance respective`,
  OK_BUTTON: 'Ok',
  CANCEL_BUTTON: 'Annuler',
  ERROR_REQUIRED_DATE: 'La date est requise',
  PAID_COMPLETE: 'Souhaitez-vous confirmer le paiement de ces factures ?',
};
